import { EmployeeIdentificationType } from '@fora-monorepo/employer-my-pages-common/types';
import { Box, Feedback, InputField, Text, TextInputFieldProps } from '@foradevelopment/fora-ui';

import { HAS_PARTIAL_DUPLICATE_MATCHES } from './constants';
import { useTypedTranslation } from '../../i18n/i18n';

type PersonalInformationFormProps = {
  identificationType: EmployeeIdentificationType | '';
  employeeIdInput: TextInputFieldProps;
  firstNameInput: TextInputFieldProps;
  lastNameInput: TextInputFieldProps;
  disabled?: boolean;
  formerWorkerFoundBlock?: boolean;
};
const inputFieldWidth = ['100%', 349, 349];

export const PersonalInformationForm = ({
  identificationType,
  employeeIdInput,
  firstNameInput,
  lastNameInput,
  disabled,
  formerWorkerFoundBlock,
}: PersonalInformationFormProps) => {
  const { t } = useTypedTranslation();

  return (
    <Box backgroundColor="white">
      {identificationType === EmployeeIdentificationType.PersonalIdentityNumber && (
        <Box width={inputFieldWidth} backgroundColor="white">
          <InputField
            disabled={disabled}
            {...employeeIdInput}
            id="personal-identity-number"
            label={t('form.addEmployee.personalIdentityNumberLabel')}
            errors={
              disabled || employeeIdInput.errors.includes(HAS_PARTIAL_DUPLICATE_MATCHES) ? [] : employeeIdInput.errors
            }
          />
        </Box>
      )}

      {identificationType === EmployeeIdentificationType.CoOrdinationNumber && (
        <Box width={inputFieldWidth} backgroundColor="white">
          <InputField
            disabled={disabled}
            {...employeeIdInput}
            id="co-ordination-number"
            label={t('form.addEmployee.coordinationNumberLabel')}
            errors={
              disabled || employeeIdInput.errors.includes(HAS_PARTIAL_DUPLICATE_MATCHES) ? [] : employeeIdInput.errors
            }
          />
        </Box>
      )}

      {/* Workaround for 154514 */}
      {formerWorkerFoundBlock && (
        <Feedback type="error" marginTop={20}>
          <Text whiteSpace="pre-wrap">{t('errorMessages.validationEmployment.formerlyRegistered')}</Text>
        </Feedback>
      )}

      <Box width={inputFieldWidth} marginTop={30} backgroundColor="white">
        <InputField
          disabled={formerWorkerFoundBlock || disabled}
          {...firstNameInput}
          id="firstname"
          label={t('form.addEmployee.firstNameLabel')}
        />
      </Box>

      <Box width={inputFieldWidth} marginTop={30} backgroundColor="white">
        <InputField
          disabled={formerWorkerFoundBlock || disabled}
          {...lastNameInput}
          id="lastname"
          label={t('form.addEmployee.lastNameLabel')}
        />
      </Box>
    </Box>
  );
};
